<template>
  <transition name="popup-fade">
    <div class="modal__bg _fast-order" v-if="opened">
      <div class="modal__layout">
        <div class="modal__container _fast-order">
          <a href="javascript:void(0);" class="modal__closer" @click.prevent="$emit('close')" v-if="canBeClosed">
          </a>
          <div class="modal__content">
            <slot>

            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import CloseIcon from '../icons/CloseIcon.vue';

  export default {
    name: "Popup",
    components: {
      CloseIcon,
    },
    props: {
      opened: {
        type: Boolean,
        default: false
      },
      canBeClosed: {
        type: Boolean,
        default: true
      },
      isProcessing: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .popup-fade-enter-from,
  .popup-fade-leave-to {
    .modal {
      &__container {
        transform: translate3d(100%, 0, 0);
      }

      &__layout {
        background-color: var(--t);
      }
    }
  }

  .popup-fade-enter-active,
  .popup-fade-leave-active {
    .modal {
      &__layout {
        transition: background-color var(--default-timing) var(--default-transition-function);
      }
    }
  }

  .popup-fade-enter-to,
  .popup-fade-leave-from {
    .modal {
      &__container {
        transform: translate3d(0, 0, 0);
      }

      &__layout {
        background-color: var(--modal-bg);
      }
    }
  }

  .modal {
    &__container {
      transform: translate3d(0, 0, 0);
    }

    &__layout {
      background-color: var(--modal-bg);
    }

    &__closer {
      pointer-events: auto;
    }
  }
</style>